import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Subscription } from 'rxjs';
import { ApplicationStateManagerService } from '../../api/managers/application-state-manager.service';
import { ControllerManagerService } from '../../api/managers/controller-manager.service';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { LocationManagerService } from '../../api/managers/location-manager.service';
import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';
import { ToroLocation } from '../../api/models/toro-location.model';
import { Constants } from '../constants';
import { MobileDeviceService } from '../services/mobile-device.service';
import { ToroLocationState } from './../../accounts/store/toro-location/toro-location.entity';
import { getCurrentLocationDetail } from './../../accounts/store/toro-location/toro-location.selectors';


@Component({
    selector: 'app-dashboard-root',
    templateUrl: './dashboard-root.component.html',
    styleUrls: ['./dashboard-root.component.less'],
})
export class DashboardRootComponent implements OnInit, OnDestroy {
    Strings = Constants.Strings;
    Constants = Constants;
    // Subscriptions
    currentLocationSubscription: Subscription;
    locationId: number = 0;
    location: ToroLocation;
    tooltipText = 'Please select a location.';
    tooltipPlacement = 'right';
    controllersForLocationSubscription: Subscription;
    tooltipTextIrrigation = 'Please add Irrigation Devices/Controllers.';
    isControllers: boolean;
    tooltipIrrigationPlacement = 'right';
    displayWhatsNew = false;

    inlineStyle: {};

    constructor(public locationManager: LocationManagerService,
        private localCacheManager: LocalCacheManager,
        private loginAndUserManager: LoginAndUserManagerService,
        private mobileDeviceService: MobileDeviceService,
        private locationStore: Store<ToroLocationState>,
        private authManager: LoginAndUserManagerService,
        private controllerManager: ControllerManagerService,
        private applicationStateManager: ApplicationStateManagerService,
        private router: Router
    ) { }

    ngOnInit() {
        this.checkLocalStorageVersion();
        this.adjustMainContainerHeight();
        this.applicationStateManager.windowResize.pipe(untilDestroyed(this)).subscribe(() => this.adjustMainContainerHeight());

        this.currentLocationSubscription = this.locationStore.select(getCurrentLocationDetail)
            .subscribe(x => {
                this.currentLocationChanged(x);
            });

        if (sessionStorage.getItem("WhatsNewClosed") !== 'true'
            && (this.router.url.includes('/dashboard'))) {
            this.showWhatsNew();
        }
    }

    ngOnDestroy() {
        if (this.currentLocationSubscription) {
            this.currentLocationSubscription.unsubscribe();
        }
        if(this.controllersForLocationSubscription){
            this.controllersForLocationSubscription.unsubscribe();
        }
    }

    private currentLocationChanged(location: ToroLocation): void {
        if (location && location !== null) {
            this.location = location;
            this.locationId = this.location && this.location !== null ? this.location.Id : 0;
            this.tooltipPlacement = (!location) ? 'right' : null;

            console.log('currentLocationChanged ',this.location.ConnectedDevice);
            if (this.location.ConnectedDevice && this.location.ConnectedDevice !== null) {
                    this.controllersForLocationSubscription = this.controllerManager.getControllersForLocationByGatewayId(this.location.ConnectedDevice!.Id, this.locationId)
                    .subscribe(controllers => {
                        if (controllers && controllers.length > 0) {
                            this.isControllers = true;
                            this.tooltipIrrigationPlacement = (!this.isControllers) ? 'right' : null;
                        }
                    });
            }
        }
    }

    get isHamburgerMenuExpanded() {
        return this.applicationStateManager.isHamburgerMenuExpanded;
    }

    setIsHamburgerMenuExpanded($event: Event, isExpanded: boolean) {
        this.applicationStateManager.isHamburgerMenuExpanded = isExpanded;
    }

    get isMobileWidth() {
        return this.applicationStateManager.isMobileWindowWidth;
    }

    get isNavbarLockedFromExpanding() {
        return this.localCacheManager.isNavbarLockedFromExpanding;
    }

    get isNavbarNarrow() {
        if (this.localCacheManager.isNavbarLockedFromExpanding) { return true; }

        return this.localCacheManager.isNavbarNarrow;
    }

    set isNavbarNarrow(value: boolean) {
        this.localCacheManager.isNavbarNarrow = value;
    }

    get tooltipPosition(): string {
        return this.localCacheManager.isNavbarNarrow ? 'right' : 'none';
    }

    tooltipTextStr(text): string {
        return this.localCacheManager.isNavbarNarrow ? text : this.tooltipTextIrrigation;
    }
    toggleMenuWidth() {
        this.localCacheManager.isNavbarNarrow = !this.localCacheManager.isNavbarNarrow;
    }

    onSignOut() {

        this.loginAndUserManager.signOut();
        this.applicationStateManager.isHamburgerMenuExpanded = false;
    }

    onHamburgerMenuItemSelected() {
        this.applicationStateManager.isHamburgerMenuExpanded = false;
    }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    private adjustMainContainerHeight() {
        if (!this.mobileDeviceService.isMobile && !this.mobileDeviceService.isTablet) return;

        this.inlineStyle = { 'height': `${this.mobileDeviceService.mainContainerHeight}px` };
    }

    checkLocalStorageVersion() {
        let lsVersion = localStorage.getItem('appVersion');
        if (this.Constants.AppVersion !== lsVersion) {
            this.authManager.signOut();
            // this.store.dispatch(authActionTypes.LogOut());
        }
    }

    private showWhatsNew() {
        var showWhatsNew = this.localCacheManager.doNotShowWhatsNew;
        if (!showWhatsNew) {
            setTimeout(() => {
                // this.broadcastService.showPopupDialog.next({ documentType: Toro.DocumentType.WhatsNew });
                this.displayWhatsNew = !this.displayWhatsNew;

            }, 500);
        }
    }

    close() {
        if (sessionStorage.getItem("WhatsNewClosed") !== 'true') {
            sessionStorage.setItem("WhatsNewClosed", 'true');
        }
    }

}
